import { render, staticRenderFns } from "./GuideBoardModal.vue?vue&type=template&id=5a134630&lang=true&"
import script from "./GuideBoardModal.vue?vue&type=script&lang=js&"
export * from "./GuideBoardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports